import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/math/page.tsx");
